import React, {Component} from "react";
import {Link} from 'react-router-dom';
import { post } from 'axios';
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";

/*
    Importing DocTypeSelector for autocomplete Banks input box
*/
import DocTypeSelector from "../../partials/DocTypeSelector";

class MyFiles extends Component {
  render() {
    return (
      <div className="filearea">
        <p className="buttontitle">My Files</p>
        <div className="changedrop">
          <h4 className="preferences" style={{position:'relative'}}>
            <span>{this.props.filename}</span>
            <svg className="actioncaret" width="20px" height="20px" viewBox="0 0 20 20" style={{position:'absolute',right:'18px',bottom:'18px'}}>
              <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                <circle className="Oval-3" strokeWidth="0.5" cx="9" cy="9" r="9"></circle>
                <polyline className="downarrow" strokeWidth="1.0546875" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
              </g>
            </svg>
          </h4>
        </div>
      </div>
    );
  }
}
/*
    Documents view that displays the Document Uploader page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class Documents extends Component {
  constructor(props){
    super(props);
    this.state ={
      file:null
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
  }
  componentDidMount() {
    this.props.updateForm("pagename", "Documents");
    this.props.setPage("documents");
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");
      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");
      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");
      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");
      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }
  }

  onFormSubmit(e){
    e.preventDefault() // Stop form submit
    this.fileUpload(this.state.file).then((response)=>{
      console.log(response.data);
    })
  }
  onChange(e) {
    //this.setState({file:e.target.files[0]})
    //this.props.updateForm("file", e.target.files[0]);
    document.getElementById("uploaddetails").classList.remove("hidden");
    document.querySelector("label[for='docs']").focus();
    document.getElementById("docs").scrollIntoView({behavior: "smooth"});
  }

  fileUpload(file){
    const url = 'http://localhost:3000/newflow/file-uploads';
    const formData = new FormData();
    formData.append('file',file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };
    return post(url, formData, config);

  }

  render() {

      return (
          <div id="dashboard2">
            <div className="dashheader">
              {this.props.pagename}
            </div>
            <div className="dashmain" id="step-1">
                <div className="text-center topcopy">
                    <h1>Upload a File</h1>
                    <p>Need to send us a document?<br/>You can securely upload your file here.</p>
                </div>

                <form onSubmit={this.onFormSubmit} className="flowform">
                  <div className="text-center">
                    <label htmlFor="myDoc">
                      <input id="myDoc" type="file" onChange={this.onChange} />
                    </label>
                  </div>

                  <h6 className="text-center">Supported file types:<br />.pdf, .docx, .xslx, .png, .jpg, etc...<br />By uploading a file you agree to <a href="">MoneyKey’s Upload Agreement.</a></h6>

                  <div id="uploaddetails" className="hidden">
                    <div className="form-group">
                        <div className="errortip hidden" id="banktip">
                            Please provide your bank.
                        </div>
                        <label htmlFor="docs">
                          Choose Document Type
                          <DocTypeSelector />
                        </label>
                    </div>
                    <div className="form-group">
                        <label htmlFor="desc">
                          Description (optional)
                          <input id="desc" type="text" placeholder="eg Driver's License" className="form-control" />
                        </label>
                    </div>
                    <div className="button-group">
                      <button id="uploadbutton" type="submit" className="btn yesno">Save</button>
                    </div>
                  </div>

                  <p className="text-center padtop">
                    <Link to="myaccount">Cancel</Link>
                  </p>
                </form>

                <hr />

                {this.props.fileloaded && <MyFiles filename={this.props.file} />}
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => ({
    st: state.FormReducer.st,
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    file: state.FormReducer.file,
    fileloaded: state.FormReducer.fileloaded,
    doctype: state.FormReducer.doctype,
    doctypechecked: state.FormReducer.doctypechecked,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(Documents);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/Documents.js